module.exports = __webpack_public_path__ + "img/A-5.c5a9ee65.png";